// extracted by mini-css-extract-plugin
export default {"watchlistItem":"watchlistItems_watchlistItem__n91eg","type":"watchlistItems_type__bwf19","mediaName":"watchlistItems_mediaName__+cbaA","platform":"watchlistItems_platform__eTuys"};